import { Resource } from "./Resource.js";
import { Bkper } from "./Bkper.js";
/**
 *
 * This class defines the Backlog of a [[Book]].
 *
 * A Backlog is a list of pending tasks in a Book
 *
 * @public
 */
export class Backlog extends Resource {
    constructor(payload, config) {
        super(payload);
        this.config = config;
    }
    /** @internal */
    getConfig() {
        return this.config || Bkper.globalConfig;
    }
    /**
     * Returns the number of pending tasks in this Backlog.
     *
     * @returns The number of tasks in the Backlog, or undefined if not available.
     */
    getCount() {
        return this.payload.count;
    }
}
//# sourceMappingURL=Backlog.js.map